export class spAddress_State_List {
    public constructor(init?: Partial<spAddress_State_List>) {Object.assign(this, init);}
    address_state_id: string;
    entry_datetime: Date;
    state_code: string;
    state_name: string;
}

